export type LlmCostCsvEvent = {
  brandId: string;
  area: string;
  campaignId: string | null;
  campaignName: string | null;
  jobType: string | null;
  workerJobId: string | null;
  id: string;
  provider: string;
  model: string;
  success: boolean;
  estimatedCostUsd: number | null;
  inputTokens: number | null;
  outputTokens: number | null;
  totalTokens: number | null;
  cacheReadTokens: number | null;
  cacheWriteTokens: number | null;
  inputPerMillion: number | null;
  outputPerMillion: number | null;
  cacheReadPerMillion: number | null;
  cacheWritePerMillion: number | null;
  priceSource: string | null;
  priceSourceFetchedAt: string | null;
  component: string | null;
  traceId: string | null;
  createdAt: string;
};

const csvHeaders = [
  "brand_id",
  "area",
  "campaign_id",
  "campaign_name",
  "job_type",
  "worker_job_id",
  "usage_event_id",
  "provider",
  "model",
  "success",
  "estimated_cost_usd",
  "input_tokens",
  "output_tokens",
  "total_tokens",
  "cache_read_tokens",
  "cache_write_tokens",
  "input_per_million",
  "output_per_million",
  "cache_read_per_million",
  "cache_write_per_million",
  "price_source",
  "price_source_fetched_at",
  "component",
  "trace_id",
  "created_at",
] as const;

const escapeCsvCell = (value: string | number | boolean | null): string => {
  if (value === null) return "";
  const text = String(value);
  return /[",\n\r]/.test(text) ? `"${text.replaceAll('"', '""')}"` : text;
};

export const buildLlmCostCsv = (events: LlmCostCsvEvent[]): string => {
  const rows = events.map((event) => [
    event.brandId,
    event.area,
    event.campaignId,
    event.campaignName,
    event.jobType,
    event.workerJobId,
    event.id,
    event.provider,
    event.model,
    event.success,
    event.estimatedCostUsd,
    event.inputTokens,
    event.outputTokens,
    event.totalTokens,
    event.cacheReadTokens,
    event.cacheWriteTokens,
    event.inputPerMillion,
    event.outputPerMillion,
    event.cacheReadPerMillion,
    event.cacheWritePerMillion,
    event.priceSource,
    event.priceSourceFetchedAt,
    event.component,
    event.traceId,
    event.createdAt,
  ]);

  return [csvHeaders, ...rows]
    .map((row) => row.map((cell) => escapeCsvCell(cell)).join(","))
    .join("\n");
};
